import type { LanguagePack } from './types'

// Assamese. Exported as `asm` because `as` is a reserved word in TypeScript.
export const asm: LanguagePack = {
  navSaved: 'ছেভ কৰা',
  navInfo: 'তথ্য',
  homeTitle: 'আপোনাৰ কাগজখনৰ এখন ফটো তোলক',
  homeHint: 'সমঝোৱে কৈ দিব কাগজখনত কি লিখা আছে আৰু ইয়াৰ পিছত আপুনি কি কৰিব লাগিব।',
  takePhoto: 'ফটো তোলক',
  uploadFile: 'ফটো বা PDF দিয়ক',
  supportedFiles: 'ফটো (JPG, PNG, WEBP) বা PDF · 10 MB লৈকে',
  chooseLanguage: 'কোন ভাষাত বুজিব',
  privacyLine: 'আপোনাৰ কাগজখন এই ফোনতে পঢ়া হয়। আপুনি "ছেভ কৰক" নিটিপালৈকে একো ছেভ নহয়।',

  previewTitle: 'ফটোখন ঠিক আছেনে?',
  rotate: 'ঘূৰাওক',
  crop: 'কাটক',
  cropDone: 'হ’ল',
  retake: 'আকৌ তোলক',
  readNow: 'পঢ়ক',
  docLanguageLabel: 'কাগজখন কোন ভাষাত লিখা?',
  docLanguageHint: 'ইংৰাজী সদায় লগতে পঢ়া হয়।',

  stepCheck: 'ফটোখন চোৱা হৈ আছে…',
  stepRead: 'কাগজখন পঢ়া হৈ আছে…',
  stepExtract: 'দৰকাৰী কথাবোৰ বিচৰা হৈ আছে…',
  stepExplain: 'অসমীয়াত বুজাই দিয়া হৈ আছে…',
  firstTimeNote: 'প্ৰথমবাৰ অলপ বেছি সময় লাগিব, কাৰণ পঢ়াৰ টুলটো ডাউনলোড হৈ আছে।',
  cancel: 'বাতিল কৰক',

  errBadImage: 'ফটোখন অলপ অস্পষ্ট। অনুগ্ৰহ কৰি আন এখন পৰিষ্কাৰ ফটো তোলক।',
  errNoText: 'সমঝোৱে এই কাগজখনত লিখা একো বিচাৰি নাপালে।',
  errUnclearPart: 'এই অংশটো সমঝোৱে ভালদৰে পঢ়িব নোৱাৰিলে।',
  errUnsupportedLanguage: 'এই ভাষাটো এতিয়াও চলোৱা হোৱা নাই।',
  errLongDocument: 'এই কাগজখন বহুত দীঘল। প্ৰথমে দৰকাৰী পাতকেইটা বাছি লওক।',
  errFileType: 'অনুগ্ৰহ কৰি এখন ফটো (JPG, PNG, WEBP) বা PDF বাছি লওক।',
  errFileSize: 'এই ফাইলটো 10 MB-তকৈ ডাঙৰ। অনুগ্ৰহ কৰি সৰু ফাইল বাছি লওক।',
  errGeneric: 'কিবা এটা ভুল হ’ল। অনুগ্ৰহ কৰি আকৌ চেষ্টা কৰক।',
  errOcrDownload: 'পঢ়াৰ টুলটো ডাউনলোড হ’ব নোৱাৰিলে। এবাৰ ইণ্টাৰনেট চলাই আকৌ চেষ্টা কৰক।',
  warnDark: 'ফটোখন এন্ধাৰ যেন লাগিছে। ভাল পোহৰত তোলা ফটো ভালদৰে পঢ়িব পাৰি।',
  warnBlurry: 'ফটোখন অস্পষ্ট (ব্লাৰ) যেন লাগিছে। ফোনটো স্থিৰকৈ ধৰি আকৌ তোলক।',
  warnSmall: 'ফটোখন বহুত সৰু। কাগজখনৰ ওচৰৰ পৰা ফটো তোলক।',
  tryAgain: 'আকৌ চেষ্টা কৰক',

  pickPagesHint: (max) => `বেছি হ’লে ${max}টা পাত বাছি লওক।`,
  pageLabel: (n) => `পাত ${n}`,
  readSelectedPages: (n) => `${n}টা পাত পঢ়ক`,

  typeSure: (name) => `এইখন ${name} যেন লাগিছে।`,
  typeMaybe: (name) => `এইখন হয়তো ${name}, কিন্তু সমঝো সম্পূৰ্ণ নিশ্চিত নহয়।`,
  typeUnknown: 'এইখন কেনেধৰণৰ কাগজ, সমঝো সম্পূৰ্ণ নিশ্চিত নহয়।',
  docTypes: {
    income_certificate: { name: 'আয়ৰ প্ৰমাণপত্ৰ (ইনকাম চাৰ্টিফিকেট)', about: 'ইয়াত চৰকাৰী ৰেকৰ্ড অনুসৰি কোনো মানুহ বা পৰিয়ালৰ আয় লিখা থাকে।' },
    caste_certificate: { name: 'জাতিৰ প্ৰমাণপত্ৰ', about: 'ইয়াত লিখা থাকে মানুহজন কোন জাতি বা শ্ৰেণীৰ।' },
    domicile_certificate: { name: 'স্থায়ী বাসিন্দাৰ প্ৰমাণপত্ৰ', about: 'ইয়াত লিখা থাকে মানুহজন স্থায়ীভাৱে ক’ত থাকে।' },
    birth_certificate: { name: 'জন্মৰ প্ৰমাণপত্ৰ', about: 'এইখন জন্মৰ চৰকাৰী ৰেকৰ্ড।' },
    death_certificate: { name: 'মৃত্যুৰ প্ৰমাণপত্ৰ', about: 'এইখন মৃত্যুৰ চৰকাৰী ৰেকৰ্ড।' },
    electricity_bill: { name: 'বিদ্যুতৰ (কাৰেণ্টৰ) বিল', about: 'ইয়াত লিখা থাকে কিমান বিদ্যুৎ খৰচ হ’ল আৰু কিমান টকা দিব লাগিব।' },
    water_bill: { name: 'পানীৰ বিল', about: 'ইয়াত পানীৰ বাবে দিবলগীয়া টকা লিখা থাকে।' },
    ration_card: { name: 'ৰেচন কাৰ্ড বা ৰেচনৰ জাননী', about: 'এইখন চৰকাৰী দোকানৰ পৰা ৰেচন পোৱাৰ বিষয়ে।' },
    aadhaar: { name: 'আধাৰৰ কাগজ', about: 'এইখন আধাৰ নম্বৰ বা আধাৰৰ তথ্যৰ বিষয়ে।' },
    pan_card: { name: 'পেন কাৰ্ডৰ কাগজ', about: 'এইখন পেন (টেক্সৰ চিনাক্তকৰণ) নম্বৰৰ বিষয়ে।' },
    bank_notice: { name: 'বেংকৰ চিঠি', about: 'এইখন বেংকৰ পৰা অহা চিঠি বা জাননী।' },
    loan_notice: { name: 'লোনৰ (ঋণৰ) জাননী', about: 'এইখন কোনো লোন বা বাকী থকা টকাৰ বিষয়ে।' },
    income_tax_notice: { name: 'ইনকাম টেক্সৰ (আয়কৰৰ) জাননী', about: 'এইখন আয়কৰ বিভাগৰ পৰা অহা।' },
    pension: { name: 'পেঞ্চনৰ চিঠি', about: 'এইখন পেঞ্চনৰ বিষয়ে।' },
    court_notice: { name: 'আদালতৰ বা আইনী জাননী', about: 'এইখন আদালতৰ পৰা অহা বা কোনো আইনী বিষয়ৰ। ইয়াক গুৰুত্ব দিয়ক।' },
    land_record: { name: 'মাটিৰ ৰেকৰ্ড', about: 'এইখন মাটিৰ মালিক কোন বা মাটিৰ তথ্যৰ বিষয়ে।' },
    property_tax: { name: 'ঘৰ-মাটিৰ টেক্সৰ বিল', about: 'এইখন ঘৰ বা সম্পত্তিৰ টেক্সৰ বিষয়ে।' },
    scholarship: { name: 'স্কলাৰশ্বিপৰ (বৃত্তিৰ) চিঠি', about: 'এইখন পঢ়াৰ বাবে পোৱা স্কলাৰশ্বিপৰ বিষয়ে।' },
    farmer_scheme: { name: 'খেতিয়কৰ আঁচনিৰ চিঠি', about: 'এইখন খেতিয়কৰ বাবে কোনো আঁচনি বা সাহায্যৰ বিষয়ে।' },
    school_letter: { name: 'স্কুলৰ চিঠি', about: 'এইখন স্কুলৰ পৰা অহা বা পঢ়াশুনাৰ বিষয়ে।' },
    marksheet: { name: 'মাৰ্কশ্বীট বা ৰিজাল্ট', about: 'ইয়াত পৰীক্ষাৰ নম্বৰ বা ৰিজাল্ট লিখা আছে।' },
    insurance: { name: 'বীমাৰ কাগজ', about: 'এইখন কোনো বীমা পলিচিৰ বিষয়ে।' },
    traffic_challan: { name: 'ট্ৰেফিক চালান', about: 'এইখন ট্ৰেফিক বা গাড়ীৰ নিয়ম ভঙাৰ বাবে জৰিমনা।' },
    job_notice: { name: 'চাকৰি বা পৰীক্ষাৰ জাননী', about: 'এইটো চৰকাৰী চাকৰি, নিযুক্তি বা তাৰ পৰীক্ষাৰ বিষয়ে।' },
    application_receipt: { name: 'আবেদনৰ ৰচিদ', about: 'ইয়াৰ পৰা জনা যায় যে আবেদনখন জমা হৈছে।' },
    application_decision: { name: 'আবেদনৰ বিষয়ে চিঠি', about: 'ইয়াত কোনো আবেদনৰ সিদ্ধান্ত বা খবৰ দিয়া আছে।' },
    government_notice: { name: 'চৰকাৰী জাননী', about: 'এইখন কোনো চৰকাৰী অফিচৰ জাননী বা আদেশ।' },
    lab_report: { name: 'চিকিৎসা পৰীক্ষাৰ ৰিপৰ্ট', about: 'ইয়াত তেজ বা আন চিকিৎসা পৰীক্ষাৰ ফলাফল আছে।' },
    rental_agreement: { name: 'ভাড়াৰ চুক্তি', about: 'এইখন ঘৰৰ গৰাকী আৰু ভাড়াতীয়াৰ মাজৰ চুক্তি।' },
    loan_agreement: { name: 'ঋণৰ চুক্তি', about: 'ইয়াত ঋণৰ চৰ্তসমূহ আছে: সুত, EMI আৰু মাচুল।' },
    contract: { name: 'এখন চুক্তি', about: 'এইখন এনে এখন চুক্তি, যাৰ চৰ্ত দুয়োপক্ষই মানিব লাগে।' },
    unknown: { name: 'এখন কাগজ', about: '' }
  },

  seedhiBaat: 'সহজ কথাত',
  docSays: 'কাগজখনত লিখা আছে',
  samjhoSays: 'সমঝোৱে বুজাইছে',
  unclearText: 'এই অংশটো পৰিষ্কাৰকৈ পঢ়া নগ’ল — অনুগ্ৰহ কৰি আচল কাগজখন চাওক।',

  aboutPerson: (name) => `এই কাগজখন এওঁৰ বিষয়ে: ${name}।`,
  issuedBy: (authority) => `এইখন ইয়াৰ পৰা আহিছে: ${authority}।`,
  status: {
    approved: 'আবেদনখন মঞ্জুৰ হৈছে।',
    rejected: 'আবেদনখন নামঞ্জুৰ (ৰিজেক্ট) কৰা হৈছে।',
    pending: 'আবেদনখনৰ কাম এতিয়াও চলি আছে। এতিয়ালৈকে সিদ্ধান্ত হোৱা নাই।',
    cancelled: 'এইখন বাতিল কৰা হৈছে।'
  },
  dateSentence: {
    deadline: (d) => `শেষ তাৰিখ: ${d}।`,
    due: (d) => `টকা দিয়াৰ শেষ তাৰিখ: ${d}।`,
    hearing: (d) => `কাগজখনত উপস্থিত থাকিবলৈ এই তাৰিখ দিয়া আছে: ${d}।`,
    issue: (d) => `এই কাগজখন ${d} তাৰিখে দিয়া হৈছিল।`,
    validity: (d) => `এইখন ${d} লৈকে বৈধ।`,
    birth: (d) => `জন্মৰ তাৰিখ লিখা আছে: ${d}।`,
    other: (d) => `এটা তাৰিখ লিখা আছে: ${d}।`
  },
  daysLeft: (days) => `আৰু ${days} দিন বাকী আছে।`,
  dueToday: 'এই তাৰিখটো আজিয়েই।',
  datePassed: 'মন কৰিব: এই তাৰিখটো পাৰ হৈ গৈছে।',
  amountSentence: {
    payable: (a) => `দিবলগীয়া টকা: ${a}।`,
    income: (a) => `আয় লিখা আছে: ${a}।`,
    fine: (a) => `জৰিমনা বা পলমৰ চাৰ্জ লিখা আছে: ${a}।`,
    fee: (a) => `মাচুল (ফী) লিখা আছে: ${a}।`,
    sanctioned: (a) => `মঞ্জুৰ হোৱা বা পঠোৱা টকা: ${a}।`,
    other: (a) => `এটা টকাৰ অংক লিখা আছে: ${a}।`
  },
  actionsPointer: 'কাগজখনত আপোনাক কিবা কৰিবলৈ কোৱা হৈছে। তলত "আপুনি কি কৰিব লাগিব" চাওক।',
  noActionFound: 'কাগজখনত আপোনাক কিবা কৰিবলৈ কোৱা হৈছে নে নাই, সেয়া পৰিষ্কাৰকৈ লিখা নাই।',
  keepSafe: 'এই কাগজখন যতনাই ৰাখক।',
  doBefore: (d) => `${d} তাৰিখৰ আগতে এই কামটো কৰক।`,
  bringDocs: (list) => `এই কাগজবোৰ সাজু কৰি ৰাখক: ${list}।`,
  contactFor: (c) => `কিবা সুধিবলগীয়া থাকিলে ইয়াত যোগাযোগ কৰক: ${c}।`,
  warningPointer: 'কাগজখনত এটা সতৰ্কবাণী লিখা আছে। সেইটো মন দি পঢ়ক।',
  rejectedNext: 'যদি আপোনাৰ ভুল হৈছে যেন লাগে, তেন্তে যিটো অফিচৰ পৰা এই চিঠিখন আহিছে, তাত সোধক।',
  lowQuality: 'ফটোখন বৰ পৰিষ্কাৰ নাছিল, সেয়েহে কিছুমান কথা ভুলকৈ পঢ়া হ’ব পাৰে। আচল কাগজখনৰ লগত মিলাই চাওক।',

  cardTodo: 'আপুনি কি কৰিব লাগিব',
  cardDates: 'দৰকাৰী তাৰিখ',
  cardAmount: 'টকাৰ পৰিমাণ',
  cardWhere: 'ক’লৈ যাব লাগিব',
  cardWarnings: 'সাৱধান',
  cardDocs: 'কি কি কাগজ লাগিব',
  cardPerson: 'কাৰ বিষয়ে',
  cardFrom: 'কোনে পঠিয়াইছে',
  cardNumbers: 'দৰকাৰী নম্বৰ',
  cardContact: 'যোগাযোগ',
  refKinds: {
    application: 'আবেদন নম্বৰ',
    certificate: 'প্ৰমাণপত্ৰ নম্বৰ',
    consumer: 'কনজিউমাৰ নম্বৰ',
    account: 'একাউণ্ট নম্বৰ',
    case: 'কেচ নম্বৰ',
    reference: 'চিঠিৰ নম্বৰ',
    registration: 'ৰেজিষ্ট্ৰেচন নম্বৰ',
    receipt: 'ৰচিদ নম্বৰ',
    other: 'নম্বৰ'
  },
  requiredDocNames: {
    aadhaar: 'আধাৰ কাৰ্ড',
    pan: 'পেন কাৰ্ড',
    ration_card: 'ৰেচন কাৰ্ড',
    voter_id: 'ভোটাৰ কাৰ্ড',
    passbook: 'বেংকৰ পাছবুক',
    photo: 'ফটো',
    income_certificate: 'আয়ৰ প্ৰমাণপত্ৰ',
    caste_certificate: 'জাতিৰ প্ৰমাণপত্ৰ',
    domicile_certificate: 'স্থায়ী বাসিন্দাৰ প্ৰমাণপত্ৰ',
    birth_certificate: 'জন্মৰ প্ৰমাণপত্ৰ',
    land_record: 'মাটিৰ ৰেকৰ্ড',
    electricity_bill: 'বিদ্যুতৰ বিল',
    address_proof: 'ঠিকনাৰ প্ৰমাণ',
    id_proof: 'পৰিচয়ৰ প্ৰমাণ',
    affidavit: 'শপতনামা (এফিডেভিট)',
    application_form: 'আবেদনৰ ফৰ্ম'
  },

  voiceDownloadNote: 'প্ৰথমবাৰ মাত ডাউনলোড হৈছে (প্ৰায় 58 MB)। তাৰ পিছত ইণ্টাৰনেট নোহোৱাকৈও চলিব।',

  listen: 'শুনক',
  pause: 'ৰখাওক',
  resume: 'বাকীখিনি শুনক',
  stop: 'বন্ধ কৰক',
  noVoice: 'এই ফোনত অসমীয়া মাত (ভইচ) নাই।',
  noVoiceHint: 'ফোনৰ ছেটিংত (Text-to-speech) মাত যোগ কৰিব পাৰে, বা আন ভাষাত শুনক।',
  listenInHindi: 'হিন্দীত শুনক',
  listenInEnglish: 'ইংৰাজীত শুনক',
  noSpeechSupport: 'এই ব্ৰাউজাৰে মাতি পঢ়ি শুনাব নোৱাৰে।',

  disclaimer: 'সমঝোৱে আপোনাৰ কাগজখন সহজকৈ বুজায়। দৰকাৰী কথাবোৰ সদায় আচল কাগজখন বা যিটো অফিচে কাগজখন দিছে, তেওঁলোকৰ লগত মিলাই চাওক। সমঝো চৰকাৰী সেৱা নহয় আৰু এইটো আইনী পৰামৰ্শ নহয়।',
  fullText: 'সমঝোৱে কি পঢ়িলে',
  fullTextHint: 'ৰং কৰা শাৰীবোৰ পৰিষ্কাৰকৈ পঢ়িব পৰা নগ’ল।',
  newDocument: 'নতুন কাগজ',
  save: 'এই ফোনত ছেভ কৰক',
  saved: 'এই ফোনত ছেভ হ’ল',
  share: 'শ্বেয়াৰ কৰক',
  copied: 'কপি হ’ল',
  translateLines: 'কাগজখনৰ ইংৰাজী শাৰীবোৰ অসমীয়াত চাওক',
  helperMode: 'সহায়ক ম\'ড',
  helperModeHint: 'যিসকলে আনৰ কাগজ পঢ়ি দিয়ে তেওঁলোকৰ বাবে (CSC, NGO, স্বেচ্ছাসেৱক)। ইয়াত ছেভ বন্ধ থাকে, আৰু "পৰৱৰ্তী জন" টিপিলে সকলো মচ খাই যায়।',
  nextPerson: 'পৰৱৰ্তী জন',
  listenMode: 'শুনা ম\'ড',
  listenModeHint: 'ব্যাখ্যা সাজু হোৱাৰ লগে লগে সমঝোৱে নিজেই পঢ়ি শুনায়।',
  settingsTitle: 'ছেটিংছ',
  shareVoiceNote: 'ভইচ নোট পঠিয়াওক',
  makingVoiceNote: 'ভইচ নোট তৈয়াৰ হৈ আছে…',
  voiceNoteFailed: 'এই ফোনত ভইচ নোট তৈয়াৰ কৰিব পৰা নগ\'ল।',
  translateOtherLines: 'কাগজখনৰ অন্য ভাষাৰ শাৰীবোৰ অসমীয়াত চাওক',
  translateAiNote: 'যিবোৰ শাৰী ইংৰাজীত নহয়, সেইবোৰ এটা AI সেৱাই (Groq) অনুবাদ কৰে।',
  translateConsent: 'অনুবাদৰ বাবে এই শাৰীবোৰ ইণ্টাৰনেটেৰে সমঝোৰ চাৰ্ভাৰলৈ পঠোৱা হ’ব। তাত ছেভ কৰা নহয়। আধাৰ আৰু ফোনৰ দৰে নম্বৰবোৰ আগতেই আঁতৰাই দিয়া হয়।',
  translateConfirm: 'হয়, অনুবাদ কৰক',
  translating: 'অনুবাদ হৈ আছে…',
  translateNote: 'মেচিনে কৰা অনুবাদ — ভুল থাকিব পাৰে।',
  translateFailed: 'এতিয়া অনুবাদ কৰিব পৰা নাই।',
  retryRotated: 'ফটো ঘূৰাই আকৌ পঢ়ক',

  addToCalendar: 'কেলেণ্ডাৰত ৰিমাইণ্ডাৰ যোগ কৰক',
  askTitle: 'এই কাগজখনৰ বিষয়ে সোধক',
  askHint: 'নিজৰ ভাষাত সোধক। সমঝোৱে আপোনাৰ কাগজৰ পৰা উত্তৰ দিব — আৰু তাত নাথাকিলে, কেৱল চৰকাৰী ৱেবছাইটৰ পৰা।',
  askPlaceholder: 'আপোনাৰ প্ৰশ্ন লিখক বা কওক…',
  askSend: 'সোধক',
  askMic: 'কৈ সোধক',
  askListening: 'শুনি আছে… এতিয়া কওক',
  askWebToggle: 'প্ৰয়োজন হ’লে চৰকাৰী ৱেবছাইটো চোৱা হ’ব',
  askConsent: 'উত্তৰ দিবলৈ এই কাগজৰ লিখা আৰু আপোনাৰ প্ৰশ্ন ইণ্টাৰনেটেৰে সমঝোৰ চাৰ্ভাৰ আৰু এটা AI সেৱালৈ (Groq) পঠোৱা হ’ব। আধাৰ, পেন, ফোন নম্বৰ আৰু ইমেইল আগতেই আঁতৰাই দিয়া হয়। একো ছেভ কৰা নহয়।',
  askOfficialOnly: 'কেৱল চৰকাৰী ৱেবছাইট চোৱা হয়, যেনে:',
  askConsentConfirm: 'ঠিক আছে, সোধক',
  askThinkingDoc: 'আপোনাৰ কাগজ পঢ়ি আছে',
  askThinkingWeb: 'চৰকাৰী ৱেবছাইট চাই আছে',
  askFromDoc: 'আপোনাৰ কাগজৰ পৰা',
  askFromWeb: 'চৰকাৰী ৱেবছাইটৰ পৰা',
  askNotFound: 'সমঝোৱে এই কথা আপোনাৰ কাগজত বা চৰকাৰী ৱেবছাইটত বিচাৰি নাপালে। যি কাৰ্যালয়ে এই কাগজ পঠিয়াইছে, তেওঁলোকক সোধক।',
  askUnverified: 'সমঝোৱে এইটো কাগজৰ কোনো নিৰ্দিষ্ট শাৰীৰ সৈতে মিলাব নোৱাৰিলে। কাগজখন চাই পৰীক্ষা কৰক।',
  askSources: 'উৎস',
  askOfficial: 'চৰকাৰী',
  askFailed: 'এতিয়া উত্তৰ পোৱা নগ’ল। আকৌ চেষ্টা কৰক।',
  askBusy: 'এতিয়া বহুত প্ৰশ্ন আহি আছে। এক মিনিট ৰৈ আকৌ সোধক।',
  askAiNote: 'এই উত্তৰবোৰ AI-য়ে লিখিছে, ভুল থাকিব পাৰে। দৰকাৰী কথা কাৰ্যালয়ৰ পৰা নিশ্চিত কৰক।',
  askTryNext: 'আপুনি এইটোও সুধিব পাৰে:',
  askJump: 'প্ৰশ্ন সোধক',
  askSuggest: {
    fillForm: 'এই প্ৰপত্ৰখন কেনেকৈ পূৰণ কৰিম? প্ৰতিটো ঘৰ বুজাই দিয়ক।',
    first: 'মই প্ৰথমে কি কৰিব লাগে?',
    deadline: 'শেষ তাৰিখ পাৰ হৈ গ’লে কি হ’ব?',
    pay: 'এইটো কেনেকৈ আৰু ক’ত জমা দিম?',
    papers: 'এই কাগজবোৰ ক’ৰ পৰা পাম?',
    rejected: 'এইটো কিয় বাতিল হ’ল, আৰু এতিয়া মই কি কৰিব পাৰোঁ?',
    meaning: 'এই কাগজখন বৰ সহজ ভাষাত বুজাই দিয়ক।',
    contact: 'এই বিষয়ে কাৰ সৈতে যোগাযোগ কৰিম?',
    schemes: 'এই কাগজ অনুসৰি মই কোনবোৰ চৰকাৰী আঁচনিৰ যোগ্য হ’ব পাৰোঁ?'
  },

  helpTitle: 'সহায় লওক',
  nearbyTitle: 'আটাইতকৈ ওচৰৰ কাৰ্যালয়',
  nearbyNote: 'আপোনাৰ ওচৰৰ মেপ খোল খাব। আপোনাৰ অৱস্থান কেৱল মেপলৈ যায় — সমঝোৱে সেয়া নেদেখে, ছেভো নকৰে।',
  locating: 'আপোনাৰ অৱস্থান বিচাৰি আছে…',
  schemesTitle: 'চৰকাৰী আঁচনি',
  schemesText: 'এই কাগজ অনুসৰি কোনবোৰ আঁচনি আপোনাৰ কামত আহিব পাৰে, সমঝোৱে চৰকাৰী আঁচনিৰ ৱেবছাইটত চাব পাৰে।',
  schemesButton: 'মোৰ বাবে আঁচনি বিচাৰক',
  legalTitle: 'বিনামূলীয়া আইনী সহায়',
  legalText: 'আইনী সেৱা কৰ্তৃপক্ষৰ পৰা আপুনি বিনামূলীয়া উকীল পাব পাৰে — যেনে মহিলা, শিশু, SC/ST, শ্ৰমিক, দিব্যাংগ আৰু কম উপাৰ্জনৰ মানুহ।',
  legalCall: (n) => `${n}-ত ফোন কৰক (বিনামূলীয়া)`,
  legalNearby: 'আটাইতকৈ ওচৰৰ আইনী সেৱা কৰ্তৃপক্ষ',
  legalMore: 'আৰু আইনী সহায়',
  legalAskConsent: 'আপোনাৰ প্ৰশ্ন ইণ্টাৰনেটেৰে সমঝোৰ চাৰ্ভাৰ আৰু এটা AI সেৱালৈ (Groq) পঠোৱা হ’ব, যিয়ে উত্তৰ কেৱল চৰকাৰী ৱেবছাইটত বিচাৰে। আধাৰ, পেন, ফোন নম্বৰ আৰু ইমেইল আগতেই আঁতৰাই দিয়া হয়। একো ছেভ কৰা নহয়।',
  navLegal: 'আইনী সহায়'
}
